import {forwardRef} from 'react';
import type {LinkProps} from 'react-router';
import {Link} from 'react-router';

// ----------------------------------------------------------------------

interface RouterLinkProps extends Omit<LinkProps, 'to'> {
  href: string;
}

export const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(({href, ...other}, ref) => (
  <Link ref={ref} to={href} {...other} />
));

RouterLink.displayName = 'RouterLink';
